import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyBhz2nXObiLMyeYN0o3eT8hZzPsCnsxMWk",
  authDomain: "clone-59891.firebaseapp.com",
  databaseURL: "https://clone-59891.firebaseio.com",
  projectId: "clone-59891",
  storageBucket: "clone-59891.appspot.com",
  messagingSenderId: "476715603285",
  appId: "1:476715603285:web:68ea0ad7029f8f9be24bdc",
  measurementId: "G-EM6T7MYVFW",
});

// const db = firebaseApp.firestore();
const auth = firebase.auth();

export { auth };
